import { clearScoreboardConfig } from '../../utils/scoreboard';

angular.module('app.directives.schedule').directive('scoreboardTabConfig', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      sc: '=',
      showClear: '@',
    },
    template: require('./scoreboard-tab-config.html'),
    controller: function ($scope) {
      'ngInject';
      $scope.clearScoreboardConfig = function () {
        clearScoreboardConfig($scope.sc);
      };
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/scoreboard-tab-config.js